import React from 'react';
import { Link, DetailedAlertMessages } from '@sentara-health/optimahealth_web';
import { useTranslation, Trans } from 'react-i18next';
import { DeviceTypes, useDeviceType } from 'common';

const InfoBanner: React.FC = () => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === DeviceTypes.MOBILE;
  const { t } = useTranslation();

  return (
    <DetailedAlertMessages
      collapsible={true}
      defaultCollapsed={isMobile ? 'true' : ''}
      additionalInfo={
        <Trans
          i18nKey="maintenance.infoBannerMessage"
          components={{
            link1: (
              <Link
                to={t('common.memberResourcesURL')}
                target="_blank"
                className="text-decoration-underline medium-link"
                dataTestId="paymentOptionsLink"
              />
            ),
            link2: (
              <Link
                to={t('payMonthlyPremium.payMonthlyPremiumResourceUrl')}
                target="_blank"
                className="text-decoration-underline medium-link"
                dataTestId="binderPaymentLink"
              />
            ),
            br: <br />,
          }}
        />
      }
      message={t('common.importantNotice')}
      variant="bannerwarning"
      type="warning"
    ></DetailedAlertMessages>
  );
};

export default InfoBanner;